import React, { useEffect, useState } from "react";
import api, { inr } from "@/lib/api";
import { toast } from "sonner";

const STATUSES = ["Placed","Confirmed","Packed","Shipped","Out for Delivery","Delivered","Cancelled","Returned"];

export default function AdminOrders() {
  const [list, setList] = useState([]);
  const load = () => api.get("/admin/orders").then(r => setList(r.data));
  useEffect(() => { load(); }, []);
  const setStatus = async (id, status) => { await api.put(`/admin/orders/${id}/status`, { status }); load(); toast.success(`Status: ${status}`); };
  return (
    <div>
      <h1 className="font-display text-3xl font-bold mb-6">Orders</h1>
      <div className="bg-white border border-slate-100 rounded-2xl overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-xs uppercase text-slate-500"><tr><th className="text-left p-3">Order</th><th>Customer</th><th>Total</th><th>Payment</th><th>Status</th><th></th></tr></thead>
          <tbody>{list.map(o => (
            <tr key={o.order_id} className="border-t border-slate-100">
              <td className="p-3"><div className="font-mono text-xs">{o.order_id}</div><div className="text-xs text-slate-500">{new Date(o.created_at).toLocaleString()}</div></td>
              <td className="text-center text-xs">{o.address?.full_name}<br/>{o.address?.mobile}</td>
              <td className="text-center font-semibold">{inr(o.total)}</td>
              <td className="text-center text-xs">{o.payment_method}<br/><span className="text-slate-500">{o.payment_status}</span></td>
              <td className="text-center"><span className={`text-xs font-semibold px-2 py-1 rounded-full ${o.status==="Delivered"?"bg-emerald-50 text-emerald-700":o.status==="Cancelled"?"bg-red-50 text-red-700":"bg-blue-50 text-[#004BCA]"}`}>{o.status}</span></td>
              <td className="p-3 text-right">
                <select data-testid={`status-${o.order_id}`} value={o.status} onChange={e=>setStatus(o.order_id,e.target.value)} className="bg-slate-50 border border-slate-200 rounded-lg px-2 py-1 text-xs">
                  {STATUSES.map(s => <option key={s}>{s}</option>)}
                </select>
              </td>
            </tr>
          ))}</tbody>
        </table>
      </div>
    </div>
  );
}
